import '../estilos/acceso.css';
import { useIdiomaAcceso, useTextosAcceso } from '../utils/idiomaAcceso';

/**
 * Marco de las pantallas de acceso (ingreso, olvidé mi contraseña, restablecer), con el
 * molde de la familia (Payroll360 SaaS, KNOC360): regla del espectro arriba, el logo y el
 * formulario a la izquierda, el panel índigo de Finance360 a la derecha.
 */
// Los logos llevan al sitio público. En una cuenta (acme.finance360.cr) la raíz del
// subdominio abre el ingreso, así que el enlace va al dominio principal.
const SITIO = window.location.hostname.endsWith('finance360.cr') ? 'https://finance360.cr' : '/';

function TarjetaConsola({ t }) {
  return (
    <div className="flujo" aria-hidden="true">
      <div className="flujo-cab">
        <span className="tipo">FE</span>
        <span>{t.tipo}</span>
        <span className="chip ok"><i />{t.ok}</span>
      </div>
      <ol>
        {t.pasos.map(([b, s]) => <li key={b} className="hecho"><b>{b}</b><span>{s}</span></li>)}
      </ol>
      <div className="modulos">
        {t.modulos.map(m => <span key={m}>{m}</span>)}
      </div>
    </div>
  );
}

export default function MarcoAcceso({ children, rotulo, titular, texto, tarjeta, pie }) {
  const t = useTextosAcceso();
  const { idioma, cambiar } = useIdiomaAcceso();
  return (
    <div className="f360-acceso">
      <div className="regla" />
      <div className="acceso">
        <div className="acceso-izq">
          <div className="acceso-caja">
            <div className="cabeza">
              <a href={SITIO} aria-label="Finance360 · finance360.cr"><img className="logo" src="/marca/f360-logo-color-2026.svg" alt="Finance360 by Kuanta Bridge" /></a>
              <div className="idioma" role="group" aria-label={t.idioma}>
                {['es', 'en'].map(i => (
                  <button key={i} type="button" aria-pressed={idioma === i} className={idioma === i ? 'activo' : ''} onClick={() => cambiar(i)}>{i.toUpperCase()}</button>
                ))}
              </div>
            </div>
            {children}
            <p className="pie">{pie ?? t.pie}</p>
          </div>
        </div>

        <div className="acceso-der">
          {/* Anillos finos concéntricos (el arco del sitio corporativo), no manchas */}
          <svg className="anillos" viewBox="0 0 800 800" aria-hidden="true">
            {[380, 300, 220, 140].map((r, n) => (
              <circle key={r} cx="800" cy="800" r={r} fill="none" stroke="#8E98F0" strokeOpacity={0.1 + n * 0.05} strokeWidth="1.4" />
            ))}
            <path d="M 420 800 A 380 380 0 0 1 800 420" fill="none" stroke="#8E98F0" strokeWidth="2.5" strokeLinecap="round" strokeOpacity=".55" />
          </svg>
          <div className="arriba">
            <a href={SITIO} className="logo-der-enlace" aria-label="Finance360 · finance360.cr"><img className="logo-der" src="/marca/f360-logo-blanco-2026.svg" alt="" /></a>
            <span className="ojo">{rotulo ?? t.rotulo}</span>
          </div>

          {tarjeta ?? <TarjetaConsola t={t.tarjeta} />}

          <div className="texto">
            <h3>{titular ?? t.titular}</h3>
            <p>{texto ?? t.texto}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
